module.exports = __webpack_public_path__ + "static/img/title-charging-gun.8c0dc370.png";